var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.7V22.5C2 22.7761 2.22386 23 2.5 23H4.27778C4.55392 23 4.77778 22.7761 4.77778 22.5V8.7C4.77778 7.325 4.77778 3.2 9.77778 3.2H16.5C16.7761 3.2 17 3.42386 17 3.7V9.25C17 10.1667 16.4444 12 14.2222 12H12C11.0741 12 9.77778 11.45 9.77778 9.8C9.77778 8.88333 10.3333 7.6 12 7.6H14.5028C14.6547 7.6 14.7778 7.47688 14.7778 7.325V5.9C14.7778 5.62386 14.555 5.4 14.2789 5.4H9.77778C8.85185 5.4 7 6.5 7 8.7V22.5C7 22.7761 7.22386 23 7.5 23H9.27778C9.55392 23 9.77778 22.7761 9.77778 22.5V15.5C9.77778 15.2239 10.0016 15 10.2778 15H13.5H14.0222C16.8941 15 19.2222 12.6719 19.2222 9.8V4.3C19.2222 3.66862 20.1374 2.67484 20.9171 1.94269C21.2626 1.61833 21.0372 1 20.5634 1H9.77778C5.33333 1 2 3.2 2 8.7Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfc);
export default __webpack_public_path__ + "static/media/PFC.369f23868f808ff9c1538ab3da790891.svg";
export { ForwardRef as ReactComponent };